var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { gql } from "@apollo/client";
export var GET_SUPPORT_MATERIALS_ACKNOWLEDGMENT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetSupportMaterialsAcknowledgment($electionEventId: uuid!) {\n        get_support_materials_acknowledgment(election_event_id: $electionEventId) {\n            document_ids\n        }\n    }\n"], ["\n    query GetSupportMaterialsAcknowledgment($electionEventId: uuid!) {\n        get_support_materials_acknowledgment(election_event_id: $electionEventId) {\n            document_ids\n        }\n    }\n"])));
var templateObject_1;
